export default __webpack_public_path__ + "static/media/logo-sportmadness-large.6b5dd213.png";